import { render } from "./project-dashboard.vue?vue&type=template&id=5393b09e"
import script from "./project-dashboard.vue?vue&type=script&lang=js"
export * from "./project-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__